import { CommonError } from '../../types';
import { FETCH_ORDER_BOOK_FAILURE, FETCH_ORDER_BOOK_REQUEST, FETCH_ORDER_BOOK_SUCCESS } from './constants';
import { OrderBookData } from './types';

export interface FetchOrderBookRequestAction {
    type: typeof FETCH_ORDER_BOOK_REQUEST;
    payload: string;
}

export interface FetchOrderBookSuccessAction {
    type: typeof FETCH_ORDER_BOOK_SUCCESS;
    payload: OrderBookData[];
}

export interface FetchOrderBookFailureAction {
    type: typeof FETCH_ORDER_BOOK_FAILURE;
    payload: CommonError;
}

export type OrderBookActions = FetchOrderBookRequestAction | FetchOrderBookSuccessAction | FetchOrderBookFailureAction;

export const  fetchOrderBookRequest = (payload: string): FetchOrderBookRequestAction => ({
    type: FETCH_ORDER_BOOK_REQUEST,
    payload
});

export const fetchOrderBookSuccess = (OrderBookDatas: OrderBookData[]): FetchOrderBookSuccessAction => ({
    type: FETCH_ORDER_BOOK_SUCCESS,
    payload: OrderBookDatas,
});

export const fetchOrderBookFailure = (error: CommonError): FetchOrderBookFailureAction => ({
    type: FETCH_ORDER_BOOK_FAILURE,
    payload: error,
});

